import styled from '@emotion/styled';
import { token } from '@angeplus/prever-component-lib';

import { useTerms } from './terms.store';

type TermTemplateProps = {
  slug: string;
};

export const TermTemplate = (props: TermTemplateProps) => {
  const { data } = useTerms(props.slug);

  if (data?.latest_term_version?.text) {
    return (
      <TextContainer
        dangerouslySetInnerHTML={{
          __html: data?.latest_term_version?.text,
        }}
      />
    );
  }

  return null;
};

const TextContainer = styled.div`
  width: 100%;
  overflow: hidden;
  font-family: ${token.typography.fontFamily01};

  > p + p,
  > ul > li + li {
    margin: ${token.spacing.spacingXSmall} 0;
  }

  table {
    overflow-x: auto;
    display: inline-block;
    max-width: 100%;
    border: ${token.borders.borderWidthThin} solid ${token.colors.neutralXLight};

    p {
      padding: ${token.spacing.spacingXxSmall};
    }
  }
`;
